module.exports = __webpack_public_path__ + "static/media/method-3c-mob.1a7934dc.png";